import { createAsyncThunk } from '@reduxjs/toolkit';

import { CargoRepository } from '../../repositories';
import type {
  CoverageValidateRequest,
  RTCargoRequest,
  CancelOrderCostRequest,
  OrdersListRequest,
  CancelCargoOrderRequest,
} from '../../core/requests';
import { responseAdapter } from '../../adapters';
import { CARGO_SLICE_NAME } from './cargo.const';

export const getCargoStores = createAsyncThunk(
  `${CARGO_SLICE_NAME}/getCargoStores`,
  async (payload: Array<number>, { rejectWithValue }) => {
    try {
      const response = await CargoRepository.getCargoStores(payload);
      return responseAdapter.toCargoStores(response.data);
    } catch (ex) {
      return rejectWithValue(ex);
    }
  },
);
export const getVerifationCoverage = createAsyncThunk(
  `${CARGO_SLICE_NAME}/getVerificationCoverage`,
  async (payload: CoverageValidateRequest, { rejectWithValue }) => {
    try {
      const response = await CargoRepository.validateCoverage(payload);
      return responseAdapter.toValidateCoverage(response.data);
    } catch (ex) {
      return rejectWithValue(ex);
    }
  },
);
export const createOrder = createAsyncThunk(
  `${CARGO_SLICE_NAME}/createOrder`,
  async (payload: RTCargoRequest, { rejectWithValue }) => {
    try {
      const response = await CargoRepository.createOrder(payload);
      const value = responseAdapter.toCreateOrder(response.data);
      if (!value.isSuccessful) {
        return rejectWithValue(value);
      }
      return value;
    } catch (ex) {
      return rejectWithValue(ex);
    }
  },
);

export const getCargoOrderList = createAsyncThunk(
  `${CARGO_SLICE_NAME}/getOrderList`,
  async (request: OrdersListRequest, { rejectWithValue }) => {
    try {
      const response = await CargoRepository.getOrderList(request);
      return {
        orderId: request.order_id,
        storeList: request.store_ids,
        data: responseAdapter.toOrderList(response.data),
      };
    } catch (ex) {
      return rejectWithValue(ex);
    }
  },
);

export const getCancelCostOrder = createAsyncThunk(
  `${CARGO_SLICE_NAME}/getCancelCost`,
  async (request: CancelOrderCostRequest, { rejectWithValue }) => {
    try {
      const response = await CargoRepository.requestCancelCost(request);
      return responseAdapter.toCancelCost(response.data);
    } catch (ex) {
      return rejectWithValue(0);
    }
  },
);

export const cancelCargoOrder = createAsyncThunk(
  `${CARGO_SLICE_NAME}/cancelCargoOrder`,
  async (request: CancelCargoOrderRequest, { rejectWithValue }) => {
    try {
      const response = await CargoRepository.cancelOrder(request);
      return { orderId: request.rappi_order_id };
    } catch (ex) {
      return rejectWithValue(ex);
    }
  },
);
